import { createContext } from 'react';
import { i18nextDefaultInstance } from './i18nextDefaultInstance';
const I18nContext = createContext(i18nextDefaultInstance);
export { I18nContext };
if (process.env.NODE_ENV !== 'production') {
    I18nContext.displayName = 'I18nContext';
}
//# sourceMappingURL=I18nContext.js.map